import GespassServiceModel from '@/models/GespassServiceModel';

export default class ClaimByCodeModel extends GespassServiceModel {
	static get path(): string {
		return '/ticket_transfers/_claim_by_code';
	}
}
